import variablesModule from '@/store/modules/variables.module'
import { VARIABLE_REGEX_GLOBAL, VARIABLES_REGEX_SINGULAR } from '@/constants/variable-refs.constants'

class VariableRefsUtils {
  substituteVariableRefs(text) {
    const placeholders = text.match(VARIABLE_REGEX_GLOBAL) || []
    return placeholders.reduce((text, placeholder) => {
      const variableName = placeholder.match(VARIABLES_REGEX_SINGULAR)[1]
      const substitute = this.resolveSubstitution(variableName, placeholder)

      return text.replace(placeholder, substitute)
    }, text)
  }

  resolveSubstitution(value, placeholder) {
    const variables = variablesModule.getVariablesMergedWithBotScope()
    const variable = variables.find(variable => variable.name === value)
    return variable ? variable.value : placeholder
  }
}

export default new VariableRefsUtils()
